import { render, staticRenderFns } from "./MyFormPanelField.vue?vue&type=template&id=9f00667c&scoped=true&"
import script from "./MyFormPanelField.vue?vue&type=script&lang=js&"
export * from "./MyFormPanelField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f00667c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f00667c')) {
      api.createRecord('9f00667c', component.options)
    } else {
      api.reload('9f00667c', component.options)
    }
    module.hot.accept("./MyFormPanelField.vue?vue&type=template&id=9f00667c&scoped=true&", function () {
      api.rerender('9f00667c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyFormPanel/MyFormPanelField.vue"
export default component.exports